// displayLimits — how big numbers and long rows stay inside their space
// (adversarial design: "999+" for counts, "+N" for overflowing pills), pure.

// Above this a count reads as "999+": the exact number is noise in a badge.
const COUNT_CAP = 999;

export const formatCount = (n: number, locale: string): string => {
    const format = (x: number) => new Intl.NumberFormat(locale).format(x);
    return n > COUNT_CAP ? `${format(COUNT_CAP)}+` : format(n);
};

// A pill row cut to `max`, with how many were left out (shown as "+N").
// When only one would be hidden, show it instead: "+1" saves no room.
export type CappedRow<T> = {
    readonly shown: readonly T[];
    readonly hidden: number;
};

export const capRow = <T>(items: readonly T[], max: number): CappedRow<T> =>
    items.length <= max + 1
        ? { shown: items, hidden: 0 }
        : { shown: items.slice(0, max), hidden: items.length - max };
